export const MIME_TYPE_TEXT_PLAIN = 'text/plain';
export const MIME_TYPE_TEXT_HTML = 'text/html';

export default Object.freeze({
  MIME_TYPE_TEXT_PLAIN,
  MIME_TYPE_TEXT_HTML,
});
